module.exports = __webpack_public_path__ + "static/media/Marta_rec_600x600.978777e2.jpg";